export default __webpack_public_path__ + "static/media/dropdown-blue-arrow.93743602.svg";